// React
import React, { useEffect, useState } from 'react';
// External
import imageFallback from 'assets/images/image-not-available.png';
import { Image } from 'react-bootstrap';
import isEmpty from 'lodash/isEmpty';
// Style
import './styles.scss';

function BookingImage(props) {
    const [imageUrl, setImageUrl] = useState(null);

    // Get the order image and then set it when ready
    useEffect(async() => {
        let objGetBookingImageResponse = await props.bookingImage;
        
        if (objGetBookingImageResponse?.data && !isEmpty(objGetBookingImageResponse.data)) {
            setImageUrl(objGetBookingImageResponse.data[0]);
        } else {
            setImageUrl(imageFallback);
        }        
        
    }, [props.bookingImage]);
    
    return (
        <div>
            <Image
                className={'table-img' + (imageUrl === imageFallback ? ' img-fallback' : '')}
                src={imageUrl}
                height="80"
                onError={(evt) => {
                    evt.target.src = imageFallback;
                    evt.target.classList.add('img-fallback');
                }}
                onClick={e => props.onClick(e, imageUrl)}
            />
        </div>
    );
}
export default BookingImage;